import React from "react";

import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";

import Button from "@atoms/Button";
import Dim from "@atoms/Dim";
import Icon from "@atoms/Icon";

interface IProps {
  handleCancel: () => void;
  children: React.ReactNode;
}

export default function RecruitLayout({ handleCancel, children }: IProps) {
  const { isPC } = useCheckDevice();

  return (
    <>
      <Dim onClick={handleCancel} />
      <section className="pc:h-dvh pc:max-h-dvh pc:w-1/3 pc:p-5 pc:z-50 pc:gap-5 fixed top-0 right-0 z-40 flex h-dvh w-full flex-col bg-white p-4 lg:w-1/4 dark:text-white">
        {isPC ? (
          <div className="flex w-full justify-between">
            <span>Recruit</span>
            <Button as="text" onClick={handleCancel}>
              Close
            </Button>
          </div>
        ) : (
          <div className="tnt-gap-x grid h-13.5 min-h-13.5 grid-cols-8 items-center py-4">
            <Button as="wrapper" className="col-span-1" onClick={handleCancel}>
              <Icon className="h-3.5 dark:text-white" name="LeftArrow" />
            </Button>
            <Button as="text" className="col-span-7 text-base!" onClick={handleCancel}>
              Back
            </Button>
          </div>
        )}

        {children}
      </section>
    </>
  );
}
